// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3Y-mb","inputDescription":"styles_inputDescription__3P2ol"};